import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";

export default function SipHeader({ metalType, goldPrice, silverPrice }) {
  const [timer, setTimer] = useState(180);
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
  };
  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      clearInterval(countdown);
    }
    return () => clearInterval(countdown);
  }, [timer]);
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-around",
          // justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: 0, sm: 1 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 100,
              borderRadius: 20,
              // backgroundColor: "#cfbae5",
              backgroundColor: metalType == "Gold" ? "#dac073" : "#dadad8",
              "&:hover": {
                // backgroundColor: "#b7a0cf",
                backgroundColor: metalType == "Gold" ? "#e3c87a" : "#dfdfdd",
              },
            }}
          >
            <Typography variant="h6" sx={{ fontSize: { xs: 13, sm: 14 }, p: { xs: 0.5, sm: 1 } }}>
              {metalType}
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: {
                xs: "1rem",
                sm: "1.5rem",
              },
            }}
          >
            {metalType} Live Price
          </Typography>
          {/* <Typography variant={{ xs: "body1", sm: "h5" }}>{metalType} Live Price</Typography> */}
          <Typography variant="h6" sx={{
            color: metalType == "Gold" ? "gold" : "silver", fontSize: {
              xs: "0.8rem",
              sm: "1.5rem",
            },
          }}>
            ₹{metalType == "Gold" ? goldPrice : silverPrice}/gm <sup>+3% GST</sup>{" "}
          </Typography>
          <Typography sx={{ fontSize: { xs: 11, sm: 14 } }}>{metalType == "Gold" ? "24K 99.9% Pure Gold" : "99.9% Pure Silver"}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
            // justifyContent: "space-between",
          }}
        >
          <Box maxWidth={{ xs: "50px", sm: "100px" }} >
            <img width="100px" src={metalType == "Gold" ? "/img/gold_shield.png" : "/img/silver_shield.png"} alt="gold" />
          </Box>
          <Typography sx={{ fontSize: { xs: 11, sm: 14 } }}>{metalType} Rate Expires in {formatTime(timer)} </Typography>

        </Box>
      </Box>
    </Box>
  )
}
